import { FileIcon, PastVisitsRowIcon, SyringeIcon } from "../../../components/Icons";
import { GeneralCareItem, IPetItemResponse } from "../../../services/Standard-of-care/standard-of-care.interface";
import React, { useEffect, useState } from "react";

import HealthRecordsAccordion from "./HealthRecordsAccordion";
import MedicalRecordsSection from "./MedicalRecordsSection/MedicalRecordsSection";
import PastVisitsContainer from "../PastVisitsContainer/PastVisitsContainer";
import RabiesCertificateSection from "./RabiesCertificateSection/RabiesCertificateSection";
import { Typography } from "@mui/material";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { userActivityLogger } from "../../../utils/mixpanel";

type Props = {
  careData: GeneralCareItem;
  petData: IPetItemResponse;
}

export const HEALTH_RECORDS_SECTIONS = {
  RABIES_CERTIFICATE: "rabies_certificate",
  MEDICAL_RECORDS: "medical_records",
  PAST_VISITS: "past_visits",
};

const HealthRecordsContainer = (props: Props) => {
  const { careData, petData } = props;
  const [expandedSection, setExpandedSection] = useState<string | null>(null);

  const handleAccordionChange = (section: string) => {
    setExpandedSection((prev) => (prev === section ? null : section));
  };

  const handlePastVisitsToggle = () => {
    if (expandedSection !== HEALTH_RECORDS_SECTIONS.PAST_VISITS) {
      userActivityLogger(MIXPANEL_EVENTS.USER_CHECKS_PAST_VISIT,
        { pet_name: petData.name, start_from: "care_section" });
    }
    handleAccordionChange(HEALTH_RECORDS_SECTIONS.PAST_VISITS);
  };

  const handleMedicalRecordsToggle = () => {
    if (expandedSection !== HEALTH_RECORDS_SECTIONS.MEDICAL_RECORDS) {
      userActivityLogger(MIXPANEL_EVENTS.MEDICAL_RECORDS,
        { action: "expand", pet_name: petData.name });
    }
    handleAccordionChange(HEALTH_RECORDS_SECTIONS.MEDICAL_RECORDS);
  };

  const handleRabiesToggle = () => {
    if (expandedSection !== HEALTH_RECORDS_SECTIONS.RABIES_CERTIFICATE) {
      userActivityLogger(MIXPANEL_EVENTS.RABIES_CERTIFICATE,
        { action: "expand", pet_name: petData.name });
    }
    handleAccordionChange(HEALTH_RECORDS_SECTIONS.RABIES_CERTIFICATE);
  };

  useEffect(() => {
    setExpandedSection(null);
  }, [petData.id]);

  return (
    <div className="flex flex-col gap-4 h-full">
      <Typography variant="h4" className="font-semibold">Health Records</Typography>

      <HealthRecordsAccordion
        id={HEALTH_RECORDS_SECTIONS.RABIES_CERTIFICATE}
        icon={<SyringeIcon />}
        label="Rabies Certificate"
        expanded={expandedSection === HEALTH_RECORDS_SECTIONS.RABIES_CERTIFICATE}
        onToggle={handleRabiesToggle}
      >
        <RabiesCertificateSection
          petData={petData}
          expanded={expandedSection === HEALTH_RECORDS_SECTIONS.RABIES_CERTIFICATE}
        />
      </HealthRecordsAccordion>

      <HealthRecordsAccordion
        id={HEALTH_RECORDS_SECTIONS.MEDICAL_RECORDS}
        icon={<FileIcon />}
        label="Medical Records"
        expanded={expandedSection === HEALTH_RECORDS_SECTIONS.MEDICAL_RECORDS}
        onToggle={handleMedicalRecordsToggle}
      >
        <MedicalRecordsSection
          petData={petData}
          expanded={expandedSection === HEALTH_RECORDS_SECTIONS.MEDICAL_RECORDS}
        />
      </HealthRecordsAccordion>

      <HealthRecordsAccordion
        id={HEALTH_RECORDS_SECTIONS.PAST_VISITS}
        icon={<PastVisitsRowIcon />}
        label="Past Visits"
        expanded={expandedSection === HEALTH_RECORDS_SECTIONS.PAST_VISITS}
        onToggle={handlePastVisitsToggle}
      >
        <PastVisitsContainer pastAppointments={careData.pastAppointments} petData={petData} />
      </HealthRecordsAccordion>
    </div>
  );
};

export default HealthRecordsContainer;
